function FooterPage() {
    return (
        <main className="footer-page">
                <div className="footer-logo"/>
        </main>
    )
}

export default FooterPage;